/** @jsxImportSource @emotion/react */
import React from 'react';
import { PrivacyModal } from '../features/auth/components/PrivacyModal';
import { Header } from './Header';
import style from './page.style';

interface PageProps {
  children: JSX.Element;
  title: string;
}

export const Page: React.FunctionComponent<PageProps> = (props): JSX.Element => {
  const { children, title } = props;
  return (
    <>
      <Header title={title} />
      <PrivacyModal />
      <div css={style.container}>{children}</div>
    </>
  );
};
